import TextButton from "components/textButton/TextButtonLegacy";

interface MapViewProps {
  mapsLink: string;
  address: string;
}

export default function MapView({ address, mapsLink }: MapViewProps) {
  return (
    <>
      {mapsLink && (
        <div className="mt-[50px]">
          <h2 className="mb-3 font-bold text-[24px] text-black-rock md:mb-[14px]">
            Our Office
          </h2>
          <div className="mb-[70px] flex w-100 flex-col md:flex-row">
            <iframe
              title="map"
              src={mapsLink}
              style={{ border: "0" }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-100"
            ></iframe>
            <div className="flex w-100 flex-col justify-center bg-black-rock px-[17px] py-[30px]">
              <p className="mb-[21px] text-center font-bold text-[18px] leading-[130%] text-white">
                {address}
              </p>
              <TextButton
                target="_blank"
                rel="noreferrer noopener"
                withIcon
                className="mx-auto text-center"
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  address
                )}`}
              >
                View in Google Maps
              </TextButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
